export enum TimeCardEntryType {
  Task = 'Task',
  BundleTask = 'BundleTask',
  AgentStartLocation = 'AgentStartLocation',
  AgentEndLocation = 'AgentEndLocation',
  Break = 'Break',
  Stop = 'Stop',
  Move = 'Move',
  Unknown = 'Unknown'
}
